import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import FocusSynopsisEditor from 'components/editor/movies/synopsis/synopsisFocus';
import UniversalSynopsisEditor from 'components/editor/movies/synopsis/synopsisUniversal';

export default (props) => {
	if (isFocusStudio()) return <FocusSynopsisEditor {...props} />;
	return <UniversalSynopsisEditor {...props} />;
};